import { handlerGetUrlParams } from '@/utils/dealUrlParams'
import request from '@/utils/request'

const prefix = '' // 江焕前缀

export function getTalentDataList(param) {
  const url = handlerGetUrlParams(`${prefix}/bus/talent/home/list`, param)
  return request({
    url,
    method: 'GET'
  })
}

// 查看详细信息
export function getVideoInfoDetail(id) {
  return request({
    url: `${prefix}/bus/video/home/${id}`,
    method: 'GET'
  })
}

// 修改视频
export function updateVideoInfo(data) {
  return request({
    url: '/bus/video',
    method: 'PUT',
    data
  })
}

// 前台获取视频列表
export function getVideoList(params) {
  const url = handlerGetUrlParams(`${prefix}/bus/video/home/list`, params)
  return request({
    url,
    method: 'GET',
  })
}

// 后台获取视频数据列表
export function getBackStageVideoList(params) {
  const url = handlerGetUrlParams(`${prefix}/bus/video/list`, params)
  return request({
    url,
    method: 'GET'
  })
}

// 删除视频
export function deleteVideoInfo(data) {
  return request({
    url: `${prefix}/bus/video/batch/del`,
    method: 'POST',
    data
  })
}

// 新增视频
export function addVideoInfo(data) {
  return request({
    url: `${prefix}/bus/video`,
    method: 'POST',
    data
  })
}

// 发布 or 下架
export function changeVideInfoStatus(data) {
  return request({
    url: `${prefix}/bus/video/status`,
    method: 'PUT',
    data
  })
}
